import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// "Try it": a signed-in supplier or an existing demo goes straight to Projects; otherwise start a fresh isolated demo.
export const useTryIt = () => {
  const { me, refresh } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const tryIt = async () => {
    if (busy) return;
    if (me && me.orgs?.length && (!me.demo || me.demo.role === "supplier")) { navigate("/projects"); return; }
    setBusy(true);
    try {
      await api.post("/condoor/demo/start");
      await refresh();
      navigate("/projects", { replace: true });
    } catch {
      setBusy(false);
    }
  };
  return { tryIt, busy };
};
